<template>
  <v-container fluid v-show="innerShouldShow">
    <v-row>
      <v-col cols="12">
        <v-slider
          v-model="innerValue"
          v-bind="vProps"
          :label="vProps.label + ' ' + innerValue"
        ></v-slider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import formMixin from '../formMixin'
export default {
  name: 'Range',
  mixins: [formMixin],
  mounted() {
    this.fieldLoaded(); // signal to the form we are loaded
  }
}
</script>
